import {Box as ChakraBox} from '@chakra-ui/layout'
import {BoxProps} from '@chakra-ui/react'
import {forwardRef} from '@chakra-ui/system'
import * as React from 'react'

import StyleProps from 'airship/design-system/style-props'
import {Color} from 'airship/design-system/style-props/color'
import {BorderRadius} from 'airship/design-system/theme/foundations/borders'

export type Props = StyleProps &
  Pick<BoxProps, 'border' | 'borderWidth' | '__css' | 'as'> & {
    borderColor?: Color
    borderRadius?: BorderRadius
    /** The content to render inside the box */
    children?: React.ReactNode
  }

const Box = forwardRef<Props, React.FC>((props, ref) => {
  return (
    <ChakraBox {...props} ref={ref}>
      {props.children}
    </ChakraBox>
  )
})

/* The use of React.ForwardRefExoticComponent<Props> may seem odd here.
This has been added to make sure that storybook's addon-docs plugin can access the props
to build this component's storybook page. Please make sure that any changes here do
not make props inaccessible to storybook. */
export default Box as React.ForwardRefExoticComponent<
  Props & React.RefAttributes<React.FC>
>
